export const APP_CONTAINER_CLASSNAME = "contact-us-app-container";

export const APP_ROOT_CLASSNAME = "contact-us-app-root";

export const POPUP_CLASSNAME = "contact-us-app-modal";

export const DEFAULT_LANG = "en";
